const __WEBPACK_NAMESPACE_OBJECT__ = require("swagger-client/es/subtree-resolver");